import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './AnimatedWrapper.module.scss';

const AnimatedWrapper = ({ children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const currentRef = elementRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(currentRef);
        }
      },
      {
        threshold: 0.15,
      }
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div
      ref={elementRef}
      className={`${styles.wrapper} ${isVisible ? styles.visible : ''}`}
      style={{ 
        transitionDelay: `${delay}s`
      }}
    >
      {children}
    </div>
  );
};

AnimatedWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
};

export default AnimatedWrapper; 